import { create } from 'zustand'
import { db } from '../services/firebase'
import { collection, doc, getDoc, getDocs, addDoc, updateDoc, deleteDoc, query, where, serverTimestamp } from 'firebase/firestore'

export const useVCardStore = create((set) => ({
  vCards: [],
  currentVCard: null,
  loading: false,
  error: null,

  fetchUserVCards: async (userId) => {
    set({ loading: true, error: null })
    try {
      const q = query(collection(db, 'vcards'), where('userId', '==', userId))
      const snapshot = await getDocs(q)
      const vCards = snapshot.docs.map(d => ({ id: d.id, ...d.data() }))
      set({ vCards, loading: false })
    } catch (error) {
      set({ error: error.message, loading: false })
    }
  },

  fetchVCardBySlug: async (slug) => {
    set({ loading: true, error: null })
    try {
      const q = query(collection(db, 'vcards'), where('slug', '==', slug))
      const snapshot = await getDocs(q)
      if (!snapshot.empty) {
        const d = snapshot.docs[0]
        const vCard = { id: d.id, ...d.data() }
        set({ currentVCard: vCard, loading: false })
      } else {
        set({ error: 'Dkard no disponible', loading: false })
      }
    } catch (error) {
      set({ error: error.message, loading: false })
    }
  },

  fetchVCardById: async (id) => {
    set({ loading: true, error: null })
    try {
      const d = await getDoc(doc(db, 'vcards', id))
      if (d.exists()) {
        set({ currentVCard: { id: d.id, ...d.data() }, loading: false })
      } else {
        set({ error: 'Dkard no disponible', loading: false })
      }
    } catch (error) {
      set({ error: error.message, loading: false })
    }
  },

  createVCard: async (data) => {
    set({ loading: true, error: null })
    try {
      const newVCard = {
        ...data,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      }
      const docRef = await addDoc(collection(db, 'vcards'), newVCard)
      set({ loading: false })
      return docRef.id
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },

  updateVCard: async (id, data) => {
    set({ loading: true, error: null })
    try {
      await updateDoc(doc(db, 'vcards', id), {
        ...data,
        updatedAt: serverTimestamp()
      })
      set({ loading: false })
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },

  deleteVCard: async (id) => {
    set({ loading: true, error: null })
    try {
      await deleteDoc(doc(db, 'vcards', id))
      set(state => ({
        vCards: state.vCards.filter(vCard => vCard.id !== id),
        loading: false
      }))
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },

  setCurrentVCard: (vCard) => set({ currentVCard: vCard }),
  clearError: () => set({ error: null })
}))
